"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPreFetching = exports.selectFetching = exports.select = void 0;

var _lang = require("lodash/lang");

var _array = require("lodash/array");

var _object = require("lodash/object");

var _state = require("./state");
/**
 * Safely get the call status from app state
 * Fallback to defaultCall if not found
 *
 * @param  {Object} state - An object that contains all the API calls key-value stored with the following format:
 *   @param {Bool} state[apiCall].fetching
 *   @param {Bool} state[apiCall].success
 *   @param {Bool} state[apiCall].error
 * @param  {String[]} apiCalls - A string or array of strings with the [apiCall] keys to obtain the state of that call.
 * @return {Object[]} A collection of objects with the state of every apiCall in apiCalls.
 */


var select = function select(state, apiCalls) {
  var calls = (0, _array.flatten)((0, _lang.castArray)(apiCalls));
  var apiState = (0, _object.get)(state, 'api.calls');
  return calls.map(function (call) {
    return (0, _object.get)(apiState, call, _state.defaultCall);
  });
};
/**
 * Using the own select fn find if any of the calls is fetching
 * @param  {Object} state
 * @param  {String[]} calls
 * @return {Bool}
 */


exports.select = select;

var selectFetching = function selectFetching(state) {
  for (var _len = arguments.length, calls = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    calls[_key - 1] = arguments[_key];
  }

  return select(state, calls).some(function (call) {
    return call.fetching;
  });
};
/**
 * Using the own select fn find if any of the calls is prefetching
 * @param  {Object} state
 * @param  {String[]} calls
 * @return {Bool}
 */


exports.selectFetching = selectFetching;

var selectPreFetching = function selectPreFetching(state) {
  for (var _len2 = arguments.length, calls = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    calls[_key2 - 1] = arguments[_key2];
  }

  return select(state, calls).some(function (call) {
    return call.fetching && !call.success;
  });
};

exports.selectPreFetching = selectPreFetching;